import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicWidgetComponent } from './dynamic-widgets';
import { RenderWidgetDirective } from './render-widget.directive';
import { CategoriesWidgetComponent } from './categories-widget/categories-widget.component';
import { ConfigsWidgetComponent } from './configs-widget/configs-widget.component';
import { FeaturesWidgetComponent } from './features-widget/features-widget.component';
import { PricingWidgetComponent } from './pricing-widget/pricing-widget.component';
import { ProductsWidgetComponent } from './products-widget/products-widget.component';
import { PromotionsWidgetComponent } from './promotions-widget/promotions-widget.component';
import { ReviewsWidgetComponent } from './reviews-widget/reviews-widget.component';
import { ShippingWidgetComponent } from './shipping-widget/shipping-widget.component';
import { StoreManagementWidgetComponent } from './store-management-widget/store-management-widget.component';

@Component({
  selector: 'pms-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnChanges,AfterViewInit {
  @Input() index:number;
  @Input() currentComponent:any;
 // components:any[] = dynamicWidgetComponents;
  widgetComponent:DynamicWidgetComponent;
  //currentComponent:any;

  dynamicWidgetComponents:any[] = [
    {"name":"StoreManagementWidgetComponent"},
    {"name":"CategoriesWidgetComponent"},
    {"name":"ProductsWidgetComponent"},
    {"name":"ConfigsWidgetComponent"},
    {"name":"FeaturesWidgetComponent"},
    {"name":"PricingWidgetComponent"},
    {"name":"PromotionsWidgetComponent"},
    {"name":"ReviewsWidgetComponent"},
    {"name":"ShippingWidgetComponent"}
]

  @ViewChild(RenderWidgetDirective, {static: false}) pmsRenderWidget!: RenderWidgetDirective;
  
  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["index"]){
      const componentName = this.dynamicWidgetComponents[this.index].name;
      switch (componentName) {
        case "CategoriesWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(CategoriesWidgetComponent);
          break;
        case "ConfigsWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(ConfigsWidgetComponent);
          break;
        case "FeaturesWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(FeaturesWidgetComponent);
          break;
        case "PricingWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(PricingWidgetComponent);
          break;
        case "ProductsWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(ProductsWidgetComponent);
          break;
        case "PromotionsWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(PromotionsWidgetComponent);
          break;
        case "ReviewsWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(ReviewsWidgetComponent);
          break;
        case "ShippingWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(ShippingWidgetComponent);
          break;
        case "StoreManagementWidgetComponent":
          this.widgetComponent = new DynamicWidgetComponent(StoreManagementWidgetComponent);
          break;
      
        default:
          break;
      }
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loadComponent();
    }, 100);
  }

  loadComponent(){
    const viewContainerRef = this.pmsRenderWidget.viewContainerRef;
    let component = this.widgetComponent.component;
    setTimeout(() => {
      const componentRef = viewContainerRef.createComponent(component);
      componentRef.changeDetectorRef.detectChanges();
    }, 200);
    
  }



}
